export default {
    props: {
        categoryAxisAutoBaseUnitStepsMilliseconds: {
            type: Array,
            kComposite: 'categoryAxis.autoBaseUnitSteps.milliseconds'
        }, 
        categoryAxisAutoBaseUnitStepsSeconds: {
            type: Array,
            kComposite: 'categoryAxis.autoBaseUnitSteps.seconds'
        }, 
        categoryAxisAutoBaseUnitStepsMinutes: {
            type: Array,
            kComposite: 'categoryAxis.autoBaseUnitSteps.minutes'
        }, 
        categoryAxisAutoBaseUnitStepsHours: {
            type: Array,
            kComposite: 'categoryAxis.autoBaseUnitSteps.hours'
        }, 
        categoryAxisAutoBaseUnitStepsDays: {
            type: Array,
            kComposite: 'categoryAxis.autoBaseUnitSteps.days'
        }, 
        categoryAxisAutoBaseUnitStepsWeeks: {
            type: Array,
            kComposite: 'categoryAxis.autoBaseUnitSteps.weeks'
        }, 
        categoryAxisAutoBaseUnitStepsMonths: {
            type: Array,
            kComposite: 'categoryAxis.autoBaseUnitSteps.months'
        }, 
        categoryAxisAutoBaseUnitStepsYears: {
            type: Array,
            kComposite: 'categoryAxis.autoBaseUnitSteps.years'
        }, 
        categoryAxisAxisCrossingValue: {
            type: Object | Date | Array,
            kComposite: 'categoryAxis.axisCrossingValue'
        }, 
        categoryAxisBackground: {
            type: String,
            kComposite: 'categoryAxis.background'
        }, 
        categoryAxisBaseUnit: {
            type: String,
            kComposite: 'categoryAxis.baseUnit'
        }, 
        categoryAxisBaseUnitStep: {
            type: Object,
            kComposite: 'categoryAxis.baseUnitStep'
        }, 
        categoryAxisCategories: {
            type: Array,
            kComposite: 'categoryAxis.categories'
        }, 
        categoryAxisColor: {
            type: String,
            kComposite: 'categoryAxis.color'
        }, 
        categoryAxisCrosshairColor: {
            type: String,
            kComposite: 'categoryAxis.crosshair.color'
        }, 
        categoryAxisCrosshairDashType: {
            type: String,
            kComposite: 'categoryAxis.crosshair.dashType'
        }, 
        categoryAxisCrosshairOpacity: {
            type: Number,
            kComposite: 'categoryAxis.crosshair.opacity'
        }, 
        categoryAxisCrosshairTooltipBackground: {
            type: String,
            kComposite: 'categoryAxis.crosshair.tooltip.background'
        }, 
        categoryAxisCrosshairTooltipBorderColor: {
            type: String,
            kComposite: 'categoryAxis.crosshair.tooltip.border.color'
        }, 
        categoryAxisCrosshairTooltipBorderDashType: {
            type: String,
            kComposite: 'categoryAxis.crosshair.tooltip.border.dashType'
        }, 
        categoryAxisCrosshairTooltipBorderWidth: {
            type: Number,
            kComposite: 'categoryAxis.crosshair.tooltip.border.width'
        }, 
        categoryAxisCrosshairTooltipColor: {
            type: String,
            kComposite: 'categoryAxis.crosshair.tooltip.color'
        }, 
        categoryAxisCrosshairTooltipFont: {
            type: String,
            kComposite: 'categoryAxis.crosshair.tooltip.font'
        }, 
        categoryAxisCrosshairTooltipFormat: {
            type: String,
            kComposite: 'categoryAxis.crosshair.tooltip.format'
        }, 
        categoryAxisCrosshairTooltipPadding: {
            type: Number,
            kComposite: 'categoryAxis.crosshair.tooltip.padding'
        }, 
        categoryAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            kComposite: 'categoryAxis.crosshair.tooltip.padding.bottom'
        }, 
        categoryAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            kComposite: 'categoryAxis.crosshair.tooltip.padding.left'
        }, 
        categoryAxisCrosshairTooltipPaddingRight: {
            type: Number,
            kComposite: 'categoryAxis.crosshair.tooltip.padding.right'
        }, 
        categoryAxisCrosshairTooltipPaddingTop: {
            type: Number,
            kComposite: 'categoryAxis.crosshair.tooltip.padding.top'
        }, 
        categoryAxisCrosshairTooltipTemplate: {
            type: String | Function,
            kComposite: 'categoryAxis.crosshair.tooltip.template'
        }, 
        categoryAxisCrosshairTooltipVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.crosshair.tooltip.visible'
        }, 
        categoryAxisCrosshairVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.crosshair.visible'
        }, 
        categoryAxisCrosshairWidth: {
            type: Number,
            kComposite: 'categoryAxis.crosshair.width'
        }, 
        categoryAxisField: {
            type: String,
            kComposite: 'categoryAxis.field'
        }, 
        categoryAxisJustified: {
            type: Boolean,
            kComposite: 'categoryAxis.justified'
        }, 
        categoryAxisLabelsBackground: {
            type: String,
            kComposite: 'categoryAxis.labels.background'
        }, 
        categoryAxisLabelsBorderColor: {
            type: String,
            kComposite: 'categoryAxis.labels.border.color'
        }, 
        categoryAxisLabelsBorderDashType: {
            type: String,
            kComposite: 'categoryAxis.labels.border.dashType'
        }, 
        categoryAxisLabelsBorderWidth: {
            type: Number,
            kComposite: 'categoryAxis.labels.border.width'
        }, 
        categoryAxisLabelsColor: {
            type: String,
            kComposite: 'categoryAxis.labels.color'
        }, 
        categoryAxisLabelsCulture: {
            type: String,
            kComposite: 'categoryAxis.labels.culture'
        }, 
        categoryAxisLabelsDateFormatsDays: {
            type: String,
            kComposite: 'categoryAxis.labels.dateFormats.days'
        }, 
        categoryAxisLabelsDateFormatsHours: {
            type: String,
            kComposite: 'categoryAxis.labels.dateFormats.hours'
        }, 
        categoryAxisLabelsDateFormatsMonths: {
            type: String,
            kComposite: 'categoryAxis.labels.dateFormats.months'
        }, 
        categoryAxisLabelsDateFormatsWeeks: {
            type: String,
            kComposite: 'categoryAxis.labels.dateFormats.weeks'
        }, 
        categoryAxisLabelsDateFormatsYears: {
            type: String,
            kComposite: 'categoryAxis.labels.dateFormats.years'
        }, 
        categoryAxisLabelsFont: {
            type: String,
            kComposite: 'categoryAxis.labels.font'
        }, 
        categoryAxisLabelsFormat: {
            type: String,
            kComposite: 'categoryAxis.labels.format'
        }, 
        categoryAxisLabelsMargin: {
            type: Number,
            kComposite: 'categoryAxis.labels.margin'
        }, 
        categoryAxisLabelsMarginBottom: {
            type: Number,
            kComposite: 'categoryAxis.labels.margin.bottom'
        }, 
        categoryAxisLabelsMarginLeft: {
            type: Number,
            kComposite: 'categoryAxis.labels.margin.left'
        }, 
        categoryAxisLabelsMarginRight: {
            type: Number,
            kComposite: 'categoryAxis.labels.margin.right'
        }, 
        categoryAxisLabelsMarginTop: {
            type: Number,
            kComposite: 'categoryAxis.labels.margin.top'
        }, 
        categoryAxisLabelsMirror: {
            type: Boolean,
            kComposite: 'categoryAxis.labels.mirror'
        }, 
        categoryAxisLabelsPadding: {
            type: Number,
            kComposite: 'categoryAxis.labels.padding'
        }, 
        categoryAxisLabelsPaddingBottom: {
            type: Number,
            kComposite: 'categoryAxis.labels.padding.bottom'
        }, 
        categoryAxisLabelsPaddingLeft: {
            type: Number,
            kComposite: 'categoryAxis.labels.padding.left'
        }, 
        categoryAxisLabelsPaddingRight: {
            type: Number,
            kComposite: 'categoryAxis.labels.padding.right'
        }, 
        categoryAxisLabelsPaddingTop: {
            type: Number,
            kComposite: 'categoryAxis.labels.padding.top'
        }, 
        categoryAxisLabelsRotation: {
            type: Number | String,
            kComposite: 'categoryAxis.labels.rotation'
        }, 
        categoryAxisLabelsRotationAlign: {
            type: String,
            kComposite: 'categoryAxis.labels.rotation.align'
        }, 
        categoryAxisLabelsRotationAngle: {
            type: Number | String,
            kComposite: 'categoryAxis.labels.rotation.angle'
        }, 
        categoryAxisLabelsSkip: {
            type: Number,
            kComposite: 'categoryAxis.labels.skip'
        }, 
        categoryAxisLabelsStep: {
            type: Number,
            kComposite: 'categoryAxis.labels.step'
        }, 
        categoryAxisLabelsTemplate: {
            type: String | Function,
            kComposite: 'categoryAxis.labels.template'
        }, 
        categoryAxisLabelsVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.labels.visible'
        }, 
        categoryAxisLabelsVisual: {
            type: Function,
            kComposite: 'categoryAxis.labels.visual'
        }, 
        categoryAxisLineColor: {
            type: String,
            kComposite: 'categoryAxis.line.color'
        }, 
        categoryAxisLineDashType: {
            type: String,
            kComposite: 'categoryAxis.line.dashType'
        }, 
        categoryAxisLineVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.line.visible'
        }, 
        categoryAxisLineWidth: {
            type: Number,
            kComposite: 'categoryAxis.line.width'
        }, 
        categoryAxisMajorGridLinesColor: {
            type: String,
            kComposite: 'categoryAxis.majorGridLines.color'
        }, 
        categoryAxisMajorGridLinesDashType: {
            type: String,
            kComposite: 'categoryAxis.majorGridLines.dashType'
        }, 
        categoryAxisMajorGridLinesVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.majorGridLines.visible'
        }, 
        categoryAxisMajorGridLinesWidth: {
            type: Number,
            kComposite: 'categoryAxis.majorGridLines.width'
        }, 
        categoryAxisMajorGridLinesStep: {
            type: Number,
            kComposite: 'categoryAxis.majorGridLines.step'
        }, 
        categoryAxisMajorGridLinesSkip: {
            type: Number,
            kComposite: 'categoryAxis.majorGridLines.skip'
        }, 
        categoryAxisMajorTicksColor: {
            type: String,
            kComposite: 'categoryAxis.majorTicks.color'
        }, 
        categoryAxisMajorTicksSize: {
            type: Number,
            kComposite: 'categoryAxis.majorTicks.size'
        }, 
        categoryAxisMajorTicksVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.majorTicks.visible'
        }, 
        categoryAxisMajorTicksWidth: {
            type: Number,
            kComposite: 'categoryAxis.majorTicks.width'
        }, 
        categoryAxisMajorTicksStep: {
            type: Number,
            kComposite: 'categoryAxis.majorTicks.step'
        }, 
        categoryAxisMajorTicksSkip: {
            type: Number,
            kComposite: 'categoryAxis.majorTicks.skip'
        }, 
        categoryAxisMax: {
            type: Object,
            kComposite: 'categoryAxis.max'
        }, 
        categoryAxisMaxDateGroups: {
            type: Number,
            kComposite: 'categoryAxis.maxDateGroups'
        }, 
        categoryAxisMin: {
            type: Object,
            kComposite: 'categoryAxis.min'
        }, 
        categoryAxisMinorGridLinesColor: {
            type: String,
            kComposite: 'categoryAxis.minorGridLines.color'
        }, 
        categoryAxisMinorGridLinesDashType: {
            type: String,
            kComposite: 'categoryAxis.minorGridLines.dashType'
        }, 
        categoryAxisMinorGridLinesVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.minorGridLines.visible'
        }, 
        categoryAxisMinorGridLinesWidth: {
            type: Number,
            kComposite: 'categoryAxis.minorGridLines.width'
        }, 
        categoryAxisMinorGridLinesStep: {
            type: Number,
            kComposite: 'categoryAxis.minorGridLines.step'
        }, 
        categoryAxisMinorGridLinesSkip: {
            type: Number,
            kComposite: 'categoryAxis.minorGridLines.skip'
        }, 
        categoryAxisMinorTicksColor: {
            type: String,
            kComposite: 'categoryAxis.minorTicks.color'
        }, 
        categoryAxisMinorTicksSize: {
            type: Number,
            kComposite: 'categoryAxis.minorTicks.size'
        }, 
        categoryAxisMinorTicksVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.minorTicks.visible'
        }, 
        categoryAxisMinorTicksWidth: {
            type: Number,
            kComposite: 'categoryAxis.minorTicks.width'
        }, 
        categoryAxisMinorTicksStep: {
            type: Number,
            kComposite: 'categoryAxis.minorTicks.step'
        }, 
        categoryAxisMinorTicksSkip: {
            type: Number,
            kComposite: 'categoryAxis.minorTicks.skip'
        }, 
        categoryAxisName: {
            type: String,
            kComposite: 'categoryAxis.name'
        }, 
        categoryAxisPane: {
            type: String,
            kComposite: 'categoryAxis.pane'
        }, 
        categoryAxisPlotBands: {
            type: Array,
            kComposite: 'categoryAxis.plotBands'
        },         categoryAxisReverse: {
            type: Boolean,
            kComposite: 'categoryAxis.reverse'
        }, 
        categoryAxisRoundToBaseUnit: {
            type: Boolean,
            kComposite: 'categoryAxis.roundToBaseUnit'
        }, 
        categoryAxisSelectFrom: {
            type: Object,
            kComposite: 'categoryAxis.select.from'
        }, 
        categoryAxisSelectMax: {
            type: Object,
            kComposite: 'categoryAxis.select.max'
        }, 
        categoryAxisSelectMin: {
            type: Object,
            kComposite: 'categoryAxis.select.min'
        }, 
        categoryAxisSelectMousewheelReverse: {
            type: Boolean,
            kComposite: 'categoryAxis.select.mousewheel.reverse'
        }, 
        categoryAxisSelectMousewheelZoom: {
            type: String,
            kComposite: 'categoryAxis.select.mousewheel.zoom'
        }, 
        categoryAxisSelectTo: {
            type: Object,
            kComposite: 'categoryAxis.select.to'
        }, 
        categoryAxisStartAngle: {
            type: Number,
            kComposite: 'categoryAxis.startAngle'
        }, 
        categoryAxisTitleBackground: {
            type: String,
            kComposite: 'categoryAxis.title.background'
        }, 
        categoryAxisTitleBorderColor: {
            type: String,
            kComposite: 'categoryAxis.title.border.color'
        }, 
        categoryAxisTitleBorderDashType: {
            type: String,
            kComposite: 'categoryAxis.title.border.dashType'
        }, 
        categoryAxisTitleBorderWidth: {
            type: Number,
            kComposite: 'categoryAxis.title.border.width'
        }, 
        categoryAxisTitleColor: {
            type: String,
            kComposite: 'categoryAxis.title.color'
        }, 
        categoryAxisTitleFont: {
            type: String,
            kComposite: 'categoryAxis.title.font'
        }, 
        categoryAxisTitleMargin: {
            type: Number,
            kComposite: 'categoryAxis.title.margin'
        }, 
        categoryAxisTitleMarginBottom: {
            type: Number,
            kComposite: 'categoryAxis.title.margin.bottom'
        }, 
        categoryAxisTitleMarginLeft: {
            type: Number,
            kComposite: 'categoryAxis.title.margin.left'
        }, 
        categoryAxisTitleMarginRight: {
            type: Number,
            kComposite: 'categoryAxis.title.margin.right'
        }, 
        categoryAxisTitleMarginTop: {
            type: Number,
            kComposite: 'categoryAxis.title.margin.top'
        }, 
        categoryAxisTitlePadding: {
            type: Number,
            kComposite: 'categoryAxis.title.padding'
        }, 
        categoryAxisTitlePaddingBottom: {
            type: Number,
            kComposite: 'categoryAxis.title.padding.bottom'
        }, 
        categoryAxisTitlePaddingLeft: {
            type: Number,
            kComposite: 'categoryAxis.title.padding.left'
        }, 
        categoryAxisTitlePaddingRight: {
            type: Number,
            kComposite: 'categoryAxis.title.padding.right'
        }, 
        categoryAxisTitlePaddingTop: {
            type: Number,
            kComposite: 'categoryAxis.title.padding.top'
        }, 
        categoryAxisTitlePosition: {
            type: String,
            kComposite: 'categoryAxis.title.position'
        }, 
        categoryAxisTitleRotation: {
            type: Number,
            kComposite: 'categoryAxis.title.rotation'
        }, 
        categoryAxisTitleText: {
            type: String,
            kComposite: 'categoryAxis.title.text'
        }, 
        categoryAxisTitleVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.title.visible'
        }, 
        categoryAxisTitleVisual: {
            type: Function,
            kComposite: 'categoryAxis.title.visual'
        }, 
        categoryAxisType: {
            type: String,
            kComposite: 'categoryAxis.type'
        }, 
        categoryAxisVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.visible'
        }, 
        categoryAxisWeekStartDay: {
            type: Number,
            kComposite: 'categoryAxis.weekStartDay'
        }, 
        categoryAxisNotesPosition: {
            type: String,
            kComposite: 'categoryAxis.notes.position'
        }, 
        categoryAxisNotesIconBackground: {
            type: String,
            kComposite: 'categoryAxis.notes.icon.background'
        }, 
        categoryAxisNotesIconBorderColor: {
            type: String,
            kComposite: 'categoryAxis.notes.icon.border.color'
        }, 
        categoryAxisNotesIconBorderWidth: {
            type: Number,
            kComposite: 'categoryAxis.notes.icon.border.width'
        }, 
        categoryAxisNotesIconSize: {
            type: Number,
            kComposite: 'categoryAxis.notes.icon.size'
        }, 
        categoryAxisNotesIconType: {
            type: String,
            kComposite: 'categoryAxis.notes.icon.type'
        }, 
        categoryAxisNotesIconVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.notes.icon.visible'
        }, 
        categoryAxisNotesLabelBackground: {
            type: String,
            kComposite: 'categoryAxis.notes.label.background'
        }, 
        categoryAxisNotesLabelBorderColor: {
            type: String,
            kComposite: 'categoryAxis.notes.label.border.color'
        }, 
        categoryAxisNotesLabelBorderDashType: {
            type: String,
            kComposite: 'categoryAxis.notes.label.border.dashType'
        }, 
        categoryAxisNotesLabelBorderWidth: {
            type: Number,
            kComposite: 'categoryAxis.notes.label.border.width'
        }, 
        categoryAxisNotesLabelColor: {
            type: String,
            kComposite: 'categoryAxis.notes.label.color'
        }, 
        categoryAxisNotesLabelFont: {
            type: String,
            kComposite: 'categoryAxis.notes.label.font'
        }, 
        categoryAxisNotesLabelTemplate: {
            type: String | Function,
            kComposite: 'categoryAxis.notes.label.template'
        }, 
        categoryAxisNotesLabelVisible: {
            type: Boolean,
            kComposite: 'categoryAxis.notes.label.visible'
        }, 
        categoryAxisNotesLabelRotation: {
            type: Number,
            kComposite: 'categoryAxis.notes.label.rotation'
        }, 
        categoryAxisNotesLabelFormat: {
            type: String,
            kComposite: 'categoryAxis.notes.label.format'
        }, 
        categoryAxisNotesLabelPosition: {
            type: String,
            kComposite: 'categoryAxis.notes.label.position'
        }, 
        categoryAxisNotesLineDashType: {
            type: String,
            kComposite: 'categoryAxis.notes.line.dashType'
        }, 
        categoryAxisNotesLineWidth: {
            type: Number,
            kComposite: 'categoryAxis.notes.line.width'
        }, 
        categoryAxisNotesLineColor: {
            type: String,
            kComposite: 'categoryAxis.notes.line.color'
        }, 
        categoryAxisNotesLineLength: {
            type: Number,
            kComposite: 'categoryAxis.notes.line.length'
        }, 
        categoryAxisNotesData: {
            type: Array,
            kComposite: 'categoryAxis.notes.data'
        },         categoryAxisNotesVisual: {
            type: Function,
            kComposite: 'categoryAxis.notes.visual'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/CategoryAxis.js